import React, {Component} from "react";
import {Button} from "@material-ui/core";
import i18n from "i18next";

class NotFound extends Component {
    constructor(props) {
        super(props);
    }

    state = {};

    componentDidMount() {
        const cookies = document.cookie.split(";").reduce((acc, cookieStr) => {
            const index = cookieStr.indexOf("=");
            if (index === -1) return acc;

            const key = cookieStr.slice(0, index).trim();
            const val = cookieStr.slice(index + 1).trim();

            acc[key] = decodeURIComponent(val);
            return acc;
        }, {});

        console.log("al bu cookie");
        console.log(cookies);

        const accessToken = cookies['access_token'];
        const refreshToken = cookies['refresh_token'];
        const expiresIn = parseInt(cookies['expires_at']);

        if (accessToken && accessToken !== '') {
            localStorage.setItem('jwt_token', accessToken);
            localStorage.setItem('refresh_token', refreshToken);
            localStorage.setItem('access_token_expires', +new Date() + expiresIn * 1000);

            document.cookie = '';

            setTimeout(() => {
                window.location = '/';
            }, 1500);
        }
    }

    render() {
        return (
            <div className="flex flex-center flex-middle w-100 h-100vh">
                <div className="flex flex-column flex-center flex-middle" style={{maxWidth: "320px"}}>
                    <img className="mb-32" src="/assets/images/illustrations/loading.svg" height={250} alt=""/>
                    <Button
                        className="capitalize"
                        variant="contained"
                        color="primary"
                    >
                        {i18n.t('Signing, Please Wait...')}
                    </Button>
                </div>
            </div>
        );
    }
}

export default NotFound;
